import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { DestinationService } from '../admin/shared/public-api';
import { Destination } from '../admin/shared/public-api';
import { RouterModule } from '@angular/router';
import { DeviceService } from '../shared/services/device.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [CommonModule, RouterModule, NgOptimizedImage],
})
export class FooterComponent implements OnInit {
  private readonly destinationService = inject(DestinationService);
  protected readonly deviceService = inject(DeviceService);

  destinations: Destination[];
  currentYear: number;

  ngOnInit(): void {
    this.destinationService.getDestinations().subscribe((destinations) => {
      this.destinations = destinations;
    });
    this.currentYear = new Date().getFullYear();
  }

  navigateTo(url: string): void {
    window.open(url, '_blank');
  }
}
